// extracted by mini-css-extract-plugin
export default {"ldsWrapper":"Loader_ldsWrapper__Oz+0C","ldsRoller":"Loader_ldsRoller__0g1xf"};